module.exports = __webpack_public_path__ + "static/media/marker_truck_direita_success.33a4f468.png";